import "./custom.scss";
import "animate.css";
import { fonts } from "assets/fonts";
import { Auth } from "auth";
import { Dashboard } from "components/Dashboard";
import { Workspace } from "components/Workspace";
import { ConfirmProvider } from "contexts/ConfirmContext";
import { DashboardContext, useDashboardContext } from "contexts/DashboardContext";
import { ModalsContext, useModalsContext } from "contexts/ModalsContext";
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { getCurrentDashboardProps } from "util/getCurrentDashboard";
import { sanitizeDashboardGroups } from "util/dashboardGroups";
import { DASHBOARD_SAVE_CONFLICT_EVENT } from "util/wp-api";

export default function App() {
  const modalContext = useModalsContext();
  const dashboardContext = useDashboardContext();
  const { data: globalData } = dashboardContext;
  const [saveConflict, setSaveConflict] = useState(false);

  useEffect(() => {
    const showSaveConflict = () => setSaveConflict(true);
    window.addEventListener(DASHBOARD_SAVE_CONFLICT_EVENT, showSaveConflict);
    return () => window.removeEventListener(DASHBOARD_SAVE_CONFLICT_EVENT, showSaveConflict);
  }, []);

  useEffect(() => {
    if (!globalData?.activeDashboardId || !globalData?.dashboardGroups) return;

    try {
      const activeGroup = sanitizeDashboardGroups(globalData.dashboardGroups).find(
        (group) => group.id === globalData.activeDashboardGroupId,
      );
      const dashboards = activeGroup ? activeGroup.dashboards : [];
      const fontName = getCurrentDashboardProps(globalData.activeDashboardId, dashboards).fontName;
      document.body.style.fontFamily = fonts[fontName] || fonts["Lemon Milk"];
    } catch (error) {
      console.warn("Error applying font styles:", error);
      document.body.style.fontFamily = fonts["Lemon Milk"];
    }
  }, [globalData]);

  return (
    <Auth>
      {saveConflict && (
        <div className="dashboard-save-conflict" role="alert">
          <span>This dashboard changed elsewhere. Your latest edit was not saved.</span>
          <button type="button" onClick={() => window.location.reload()}>
            Reload dashboard
          </button>
        </div>
      )}
      <DashboardContext.Provider value={dashboardContext}>
        <ModalsContext.Provider value={modalContext}>
          <ConfirmProvider>
            <Router>
              <Switch>
                <Route path="/my-dashboard" component={Workspace} />
                <Route path="/" component={Dashboard} />
              </Switch>
            </Router>
          </ConfirmProvider>
        </ModalsContext.Provider>
      </DashboardContext.Provider>
    </Auth>
  );
}
